module.exports = __webpack_public_path__ + "fonts/voltaecommd.4df14eb.ttf";